import { render } from "./Contact.vue?vue&type=template&id=b6699c30"
const script = {}

import exportComponent from "D:\\Project\\skin-web\\幻灵格斗\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__